import {
  CompanyUuidEnum,
  Nullable,
  TranslationModel,
  UserAggregateModel,
} from '@lerna-core';

export const getCompanyTitle = (
  user: Nullable<UserAggregateModel>,
  translations: TranslationModel
): Nullable<string> => {
  switch (true) {
    case user?.company?.uuid === CompanyUuidEnum.iFuture:
      return translations.courses_h1_title;
    default:
      return null;
  }
};
